import React from "react";
import Topbar from "../../components/topbar/topbar";
import Footer from "../../components/footer/footer";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import "./index.css";
import { useTranslation } from "react-i18next";
export default function ThankYou() {
  const { t } = useTranslation("publicMisc");
   const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    // check if current route is /payment-cancelled
    if (location.pathname === "/thank-you-page") {
      navigate("/"); // redirect to main route
  }else{
     navigate("/");
  }
  };
  return (
    <>
      <Topbar />
       <div className="thankyou-container">
      <div className="thankyou-card">
        <img
          src="/images/Union-icon.png"
          alt={t("thankYou.iconAlt")}
          className="thankyou-icon"
        />

        <h2>{t("thankYou.title")}</h2>

        <p className="thankyou-text">
          {t("thankYou.message")}
        </p>

        <button className="rounded-btn"  onClick={handleClick}>{t("thankYou.clickHere")}</button>
      </div>
    </div>

    </>
  );
}
